export const getBreadCrumb = (area, category, cityName) => {
  const config = useRuntimeConfig()
  const baseUrl = config.app.baseURL
  if (!area) {
    return [
      { text: '黄砂レーダー' }
    ]
  } else if (cityName) {
    if (area === 'okinawa') {
      return [
        { text: '黄砂レーダー', link: baseUrl },
        { text: getAreaPrefectureName(area), link: `${baseUrl}${area}/` },
        { text: cityName }
      ]
    }
    return [
      { text: '黄砂レーダー', link: baseUrl },
      { text: getAreaByPrefKey(area).name, link: `${baseUrl}${getAreaByPrefKey(area).key}/` },
      { text: getAreaPrefectureName(area), link: `${baseUrl}${area}/` },
      { text: cityName }
    ]
  } else {
    if (area === 'okinawa') {
      return [
        { text: '黄砂レーダー', link: baseUrl },
        { text: getAreaPrefectureName(area) }
      ]
    }
    if (category === 'area') {
      return [
        { text: '黄砂レーダー', link: baseUrl },
        { text: getAreaPrefectureName(area) }
      ]
    }
    return [
      { text: '黄砂レーダー', link: baseUrl },
      { text: getAreaByPrefKey(area).name, link: `${baseUrl}${getAreaByPrefKey(area).key}/` },
      { text: getAreaPrefectureName(area) }
    ]
  }
}
